
$(document).on('click','.openMyCart',function(){
  $("nav.micarrito, .overlay-micarrito").addClass("open");
  $("body").addClass("lock");
});

$(document).on('click',".closeMyCart, .overlay-micarrito",function(){
  $("nav.micarrito, .overlay-micarrito").removeClass("open");
  $("body").removeClass("lock");
});




//////////////////
// WEBPACK FOOTER
// ./static/js/lib.min.js
// module id = UZB8
// module chunks = 1